export default __webpack_public_path__ + "static/media/icon-2.a672f3ac.svg";